export default __webpack_public_path__ + "static/media/Benton-Sans-Wide-Regular.92b0709c.otf";